import { render } from "./InventoryItemDeviceSpecs.vue?vue&type=template&id=3e9da97c"
import script from "./InventoryItemDeviceSpecs.vue?vue&type=script&lang=js"
export * from "./InventoryItemDeviceSpecs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__